export interface CostCenterModel {
  name?: string;
  costCenterId?: string;
}

export function costCenterModelFactory(json?: any): CostCenterModel {
  json = json || {};

  return {
    name: json.name || "",
    costCenterId: json.costCenterId || null,
  } as CostCenterModel;
}
